<template>
  <q-dialog ref="dialog" @hide="onDialogHide" @show="onShow" >
    <q-card>
      <q-card-section>
        <div class="text-h6">Set Session</div>
      </q-card-section>
      <q-card-section class="q-px-sm">
          <q-input ref="searchBox" inverted v-model="searchTerm" dense
                   @keyup.down="downPressed"
                   @keyup.up="upPressed"
                   @keyup.enter="enterPressed" color="none" :debounce="50" label="Search" style="width: 100%;"/>
      </q-card-section>
      <q-card-section style="max-height: 50vh" class="scroll q-pa-none">
        <q-list link class="bg-white">
          <q-item clickable v-for="(item, i) in filteredItems"
                  :key="i"
                  :active="selectedId === i" active-class="bg-teal-1 text-black"
                  class="q-ma-sm"
                  @click.native="onOKClick(item)">
            <q-item-section>
              {{item.name}}
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import store from '../store'

export default {
  data () {
    return {
      selectedId: 0,
      searchTerm: ''
    }
  },
  computed: {
    items: () => store.getters.userSessions,
    filteredItems () {
      const _vm = this
      return this.items.filter((item) => {
        return item.name.toLowerCase().includes(_vm.searchTerm.toLowerCase())
      })
    }
  },
  methods: {
    show () {
      this.$refs['dialog'].show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },
    onOKClick (result) {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      const index = store.getters.userSessions.findIndex(s => s === result)
      this.$emit('ok', { session: result, index })

      // then hiding dialog
      this.hide()
    },
    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    },
    onShow () {
      this.selectedId = 0
      this.$nextTick(() => {
        this.$refs.searchBox.select()
        this.$refs.searchBox.focus()
      })
    },
    upPressed () {
      if (this.selectedId <= 0) this.selectedId = 0
      else this.selectedId -= 1
    },
    downPressed () {
      if (this.selectedId >= this.filteredItems.length - 1) this.selectedId = this.filteredItems.length - 1
      else this.selectedId += 1
    },
    enterPressed () {
      this.onOKClick(this.filteredItems[this.selectedId])
    }
  }
}
</script>

<style>
</style>
